import {
  DEFAULT_AUTO_CLAIM_CLOSE_TIMEOUT_MS,
  DEFAULT_AUTO_CLAIM_DELAY_MS,
  DEFAULT_IDLE_TIMEOUT_MS,
  DEFAULT_INACTIVITY_TIMEOUT_MS,
  DEFAULT_MODAL_RESPONSE_TIMEOUT_MS,
  DEFAULT_RADAR_CONSENT_TIMEOUT_MS,
} from "@/config/timeouts";
import React from "react";

import { useClientConfig } from "../client-config/use-client-config";
import { TimeoutConfigContext } from "./TimeoutConfigContext.shared";

/**
 * Timeout Configuration Provider
 *
 * Provides timeout configuration values from RadarConfig API with fallback to defaults.
 */

export const TimeoutConfigProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { clientConfig, isLoading } = useClientConfig();

  const timeoutConfig = clientConfig?.timeoutConfig;

  // Get values from API or use defaults
  const idleTimeoutMs = timeoutConfig?.idleTimeoutMs ?? DEFAULT_IDLE_TIMEOUT_MS;

  const inactivityTimeoutMs =
    timeoutConfig?.inactivityTimeoutMs ?? DEFAULT_INACTIVITY_TIMEOUT_MS;

  const modalResponseTimeoutMs =
    timeoutConfig?.modalResponseTimeoutMs ?? DEFAULT_MODAL_RESPONSE_TIMEOUT_MS;

  const autoClaimDelayMs =
    timeoutConfig?.autoClaimDelayMs ?? DEFAULT_AUTO_CLAIM_DELAY_MS;

  const autoClaimCloseTimeoutMs =
    timeoutConfig?.autoClaimCloseTimeoutMs ??
    DEFAULT_AUTO_CLAIM_CLOSE_TIMEOUT_MS;

  const radarConsentTimeoutMs =
    timeoutConfig?.radarConsentTimeoutMs ?? DEFAULT_RADAR_CONSENT_TIMEOUT_MS;

  return (
    <TimeoutConfigContext.Provider
      value={{
        idleTimeoutMs,
        inactivityTimeoutMs,
        modalResponseTimeoutMs,
        autoClaimDelayMs,
        autoClaimCloseTimeoutMs,
        radarConsentTimeoutMs,
        isLoading,
      }}
    >
      {children}
    </TimeoutConfigContext.Provider>
  );
};
